import Quill from 'quill';
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import ProfilePhoto from '../components/ProfilePhoto';

const Settings = () => {

     const [passwords, setPasswords] = useState({
    current: "",
    new: "",
    confirm: "",
  });
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const togglePassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handlePasswordChange = (field, value) => {
    setPasswords((prev) => ({ ...prev, [field]: value }));
  };

  // --- Dynamic Controls ---
  const [freeTrialDays, setFreeTrialDays] = useState(7);
  const [connectRadius, setConnectRadius] = useState(100);
  const [categories, setCategories] = useState([
    "Spam",
    "Inappropriate Content",
    "Harassment",
    "Fake Profile",
    "Other",
  ]);
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [newCategoryInput, setNewCategoryInput] = useState("");

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const addCategory = () => {
    if (newCategoryInput.trim() !== "") {
      setCategories([...categories, newCategoryInput]);
      setSelectedCategory(newCategoryInput);
      setNewCategoryInput("");
    }
    };

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Settings</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Settings</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="main-body setting_page">
      <div className="row">
        {/* Tabs */}
        <ul className="nav nav-tabs" id="settingsTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="security-tab"
              data-bs-toggle="tab"
              data-bs-target="#security"
              type="button"
              role="tab"
            >
              Security &amp; Login
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="dynamic-controls-tab"
              data-bs-toggle="tab"
              data-bs-target="#dynamic-controls"
              type="button"
              role="tab"
            >
              Dynamic Controls
            </button>
          </li>
        </ul>

        {/* Tab Content */}
        <div className="tab-content" id="settingsTabContent">
          {/* Security & Login Tab */}
          <div className="tab-pane fade show active" id="security" role="tabpanel">
            <div className="row mt-3">
              <div className="col-lg-7">
                <div className="setting-profile-box setting-profile-feld">
                  <form id="securityForm" method="post">
                    {["current", "new", "confirm"].map((field, idx) => (
                      <div className="acct-field mb-3 password-field" key={field}>
                        <label className="form-label">
                          {field === "current"
                            ? "Current Password"
                            : field === "new"
                            ? "New Password"
                            : "Confirm New Password"}
                        </label>
                        <div className="position-relative">
                          <input
                            type={showPassword[field] ? "text" : "password"}
                            className="form-control password-input"
                            value={passwords[field]}
                            onChange={(e) => handlePasswordChange(field, e.target.value)}
                          />
                          <span
                            className="toggle-password"
                            onClick={() => togglePassword(field)}
                            style={{ cursor: "pointer" }}
                          >
                            <i
                              className={`bx ${
                                showPassword[field] ? "bx-show" : "bx-hide"
                              }`}
                            />
                          </span>
                        </div>
                      </div>
                    ))}
                    <div className="btn-acc">
                      <button type="submit" className="btn btn-primary btn-sm px-4">
                        Change Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Dynamic Controls Tab */}
          <div className="tab-pane fade" id="dynamic-controls" role="tabpanel">
            <div className="row mt-3">
              <div className="col-lg-7">
                <div className="setting-profile-box setting-profile-feld">
                  <form method="post">
                    {/* Free Trial Days */}
                    <div className="acct-field mb-3">
                      <label className="form-label">Free Trial Days</label>
                      <input
                        type="number"
                        className="form-control"
                        value={freeTrialDays}
                        onChange={(e) => setFreeTrialDays(e.target.value)}
                      />
                    </div>

                    {/* Connect Radius */}
                    <div className="acct-field mb-3">
                      <label className="form-label">Connect Radius</label>
                      <select
                        className="form-select"
                        value={connectRadius}
                        onChange={(e) => setConnectRadius(Number(e.target.value))}
                      >
                        {[50, 100, 150, 200].map((radius) => (
                          <option key={radius} value={radius}>
                            {radius}m
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Reporting Category */}
                    <div className="Reporting-cat-main">
                      <label className="form-label">Reporting Category</label>
                      <div className="row">
                        <div className="col-lg-6 mb-2">
                          <select
                            className="form-select"
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                          >
                            {categories.map((cat, idx) => (
                              <option key={idx} value={cat}>
                                {cat}
                              </option>
                            ))}
                          </select>
                        </div>

                        {selectedCategory === "Other" && (
                          <div className="col-lg-6">
                            <div className="d-flex gap-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Add new category"
                                value={newCategoryInput}
                                onChange={(e) => setNewCategoryInput(e.target.value)}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={addCategory}
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="btn-acc mt-3">
                      <button type="submit" className="btn btn-primary btn-sm px-4">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Tab Content */}
      </div>
    </div>

                </div>
            </div>

        </>
    )
}

export default Settings